import { api } from './api.js';

export const listerVoyages = () => api.get('/trips').then((d) => d.trips);
export const chargerVoyage = (id) => api.get(`/trips/${id}`).then((d) => d.trip);
export const creerVoyage = (donnees) => api.post('/trips', donnees).then((d) => d.trip);
export const modifierVoyage = (id, donnees) =>
  api.patch(`/trips/${id}`, donnees).then((d) => d.trip);
export const supprimerVoyage = (id) => api.delete(`/trips/${id}`);
export const changerStatut = (id, status) =>
  api.patch(`/trips/${id}/status`, { status }).then((d) => d.trip);

/** Où en est le voyage, du point de vue de celui qui l'organise. */
export const STATUTS = [
  ['planning', 'En cours de planification'],
  ['planned', 'Planifié'],
  ['archived', 'Archivé'],
];

export const libelleStatut = (statut) =>
  STATUTS.find(([cle]) => cle === statut)?.[1] ?? statut;
export const lancerGeneration = (id) =>
  api.post(`/trips/${id}/generate`).then((d) => d.trip);

export const creerItineraireVide = (tripId) =>
  api.post(`/trips/${tripId}/itinerary`).then((d) => d.trip);
export const regenererJournee = (tripId, dayIndex) =>
  api.post(`/trips/${tripId}/itinerary/days/${dayIndex}/generate`).then((d) => d.trip);
export const ajouterJournee = (tripId) =>
  api.post(`/trips/${tripId}/itinerary/days`).then((d) => d.trip);
export const supprimerJournee = (tripId, dayIndex) =>
  api.delete(`/trips/${tripId}/itinerary/days/${dayIndex}`).then((d) => d.trip);

export const ajouterElement = (tripId, donnees) =>
  api.post(`/trips/${tripId}/itinerary/items`, donnees).then((d) => d.trip);
export const modifierElement = (tripId, itemId, donnees) =>
  api.patch(`/trips/${tripId}/itinerary/items/${itemId}`, donnees).then((d) => d.trip);
export const supprimerElement = (tripId, itemId) =>
  api.delete(`/trips/${tripId}/itinerary/items/${itemId}`).then((d) => d.trip);

/** Catégories d'une étape datée, et d'une suggestion : elles ne décrivent pas la même chose. */
export const CATEGORIES_ETAPE = [
  ['visite', 'Visite'],
  ['repas', 'Repas'],
  ['transport', 'Transport'],
  ['hebergement', 'Hébergement'],
  ['loisir', 'Loisir'],
  ['autre', 'Autre'],
];

export const CATEGORIES_SUGGESTION = [
  ['ville', 'Ville'],
  ['visite', 'Visite'],
  ['nature', 'Nature'],
  ['musee', 'Musée'],
  ['activite', 'Activité'],
  ['gastronomie', 'Gastronomie'],
  ['autre', 'Autre'],
];

/** Liste fermée proposée à la création, complétée par un champ libre. */
export const TYPES_DE_VOYAGE = [
  'culture',
  'nature',
  'gastronomie',
  'farniente',
  'sport',
  'aventure',
  'romantique',
  'famille',
  'festif',
  'road-trip',
];
